import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, TextField } from '@mui/material';
import React from 'react';

type SearchCheckboxListProps = {
  filterText: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const SearchCheckboxList = ({
  filterText,
  handleChange,
}: SearchCheckboxListProps) => {
  return (
    <TextField
      variant="outlined"
      fullWidth
      value={filterText}
      onChange={handleChange}
      sx={{
        '& input': {
          padding: 0,
        },
        '& .MuiOutlinedInput-root': {
          padding: '8px',
        },
        border: '1px solid rgba(0, 0, 0, 0.12)',
        borderTopLeftRadius: '4px',
        borderTopRightRadius: '4px',
      }}
      placeholder="ค้นหา"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchCheckboxList;
